import React, { useEffect, useState, useMemo } from "react";
import { Button } from "../ui/button";
import { Card } from "../ui/card";
import { FaMoneyBillTransfer } from "react-icons/fa6";
import SVG from '../../assets/upi_logo_icon_169316.svg';
import { useDispatch, useSelector } from "react-redux";
import { driverSelector, fetchOnedriver } from "../../api/driver";
import { keyUri } from "../../key";
import axios from "axios";
import { fetchAllbooking } from "../../api/bookings";
import { getAllBookings, seatBookSelector } from "../../api/seatbooking";
import { fetchPricing } from "../../api/priceSetting";

function EarningsPage() {
  const [activeTab, setActiveTab] = useState("all");
  const [transactionTab, setTransactionTab] = useState("all");
  const dispatch = useDispatch();
  const [userData, setUserData] = useState(null);
  const { current_driver } = useSelector(driverSelector);
  const driver_id_ = localStorage.getItem("driverid") || localStorage.getItem("Driver");
  const { getAllBooks } = useSelector(seatBookSelector);
  const { currentPricing } = useSelector((state) => state.pricing);
  
  // States for transactions and wallet
  const [transactions, setTransactions] = useState([]);
  const [filteredTransactions, setFilteredTransactions] = useState([]);
  const [gstRate, setGstRate] = useState(0);
  const [platformRate, setPlatformRate] = useState(0);
  
  // Modal states
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [showAccountModal, setShowAccountModal] = useState(false);
  const [transferAmount, setTransferAmount] = useState("");
  const [bankAccount, setBankAccount] = useState({
    holderName: "",
    accountNumber: "",
    ifsc: "",
    bankName: ""
  });

  // Filter states
  const [dateFilter, setDateFilter] = useState({ from: null, to: null });
  const [minAmount, setMinAmount] = useState("");
  const [maxAmount, setMaxAmount] = useState("");
  
  // Transfer states
  const [transfersLeft, setTransfersLeft] = useState(3);
  const [transferStatus, setTransferStatus] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    dispatch(fetchOnedriver(driver_id_));
    dispatch(fetchAllbooking(driver_id_));
    dispatch(getAllBookings(driver_id_));
    dispatch(fetchPricing())
  }, [dispatch, driver_id_]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const user_phone = localStorage.getItem("phoneNumber");
        if (user_phone) {
          const response = await axios.post(
            `${keyUri.BACKEND_URI}/api/getdriverfromphone`,
            { phone: user_phone }
          );
          localStorage.setItem("Driver", response.data.driver._id);
          setUserData(response?.data?.driver);
          localStorage.setItem("authToken", response.data.token);
        } else {
          console.error("Phone number is not available.");
        }
      } catch (err) {
        console.error("Error occurred while fetching driver:", err);
      }
    };

    fetchData();
  }, []);

  // Set pricing rates
  useEffect(() => {
    if (currentPricing?.price?.[0]) {
      setGstRate(currentPricing.price[0].gst_price / 100);
      setPlatformRate(currentPricing.price[0].platform_price / 100);
    }
  }, [currentPricing]);

  // Get completed rides
  const completedRides = useMemo(() => {
    return getAllBooks?.filter(ride => 
      ride.status === "Ride Completed" || ride.status === "completed"
    ) || [];
  }, [getAllBooks]);

  console.log("----------->",completedRides[0]?.userid);

  console.log("Completed ride ->", completedRides[0]);
console.log("Booked seat rideId ->", completedRides[0]?.bookedSeats[0]?.rideId);
console.log("User name ->", completedRides[0]?.bookedSeats[0]?.rideId?.userId?.name);

console.log("User in rideId -->", completedRides[0]?.bookedSeats[0]?.rideId?.userId?.name);
console.log("User directly -->", completedRides[0]?.bookedSeats[0]?.userId?.name);



  // Generate transactions with proper status
  useEffect(() => {
    if (completedRides.length > 0) {
      const rideTransactions = completedRides.flatMap((booking) => {
        return booking.bookedSeats.map((seat) => {
          // Calculate net earnings per seat
          const grossAmount = parseFloat(seat.rideId?.payment_amount || 0);
          const netAmount = grossAmount * (1 - gstRate) * (1 - platformRate);
          
          // Determine transaction status
          let status = "completed";
          if (booking.payment_status === "pending") {
            status = "pending";
          } else if (booking.payment_status === "failed") {
            status = "failed";
          }
     console.log("Booking User:", seat.rideId?.userid?.name);


          return {
            id: `${booking._id}-${seat.seatNumber}`,
            type: "ride",
            grossAmount,
            netAmount,
            date: new Date(seat.rideId?.payment_date || booking.createdAt),
            status,
            rideId: booking._id,
            passenger: seat.rideId?.userid?.name ||seat.userId?.name || "Anonymous",
            from: booking.route?.from_location?.name || booking.from_location || "Unknown",
            to: booking.route?.to_location?.name || booking.to_location || "Unknown"
          };
        });
      });
  
      // Add withdrawal transactions
      const withdrawalTransactions = transactions.filter(t => t.type === "withdrawal");
      
      setTransactions([...rideTransactions, ...withdrawalTransactions]);
    }
  }, [completedRides, gstRate, platformRate]);

  // Calculate earnings and wallet balance
  const { totalEarnings, walletBalance } = useMemo(() => {
    let total = 0;
    let wallet = parseFloat(current_driver?.wallet_amount?.$numberDecimal || 0);

    transactions.forEach(t => {
      if (t.type === "ride" && t.status === "completed") {
        total += t.netAmount;
      }
      if (t.type === "withdrawal") {
        wallet += t.amount; // withdrawals are negative
      }
    });

    return {
      totalEarnings: total,
      walletBalance: wallet
    };
  }, [transactions, current_driver]);

  // Filter transactions based on active filters
  useEffect(() => {
    let result = [...transactions];

    // Filter by transaction type tab
    if (transactionTab === "pending") {
      result = result.filter(t => t.status === "pending");
    } else if (transactionTab === "completed") {
      result = result.filter(t => t.status === "completed");
    }

    // Filter by date range
    if (dateFilter.from && dateFilter.to) {
      result = result.filter(t => {
        const transDate = new Date(t.date);
        return transDate >= dateFilter.from && transDate <= dateFilter.to;
      });
    }

    // Filter by amount range
    if (minAmount) {
      const min = parseFloat(minAmount);
      result = result.filter(t => Math.abs(t.netAmount || t.amount) >= min);
    }

    if (maxAmount) {
      const max = parseFloat(maxAmount);
      result = result.filter(t => Math.abs(t.netAmount || t.amount) <= max);
    }

    setFilteredTransactions(result);
  }, [transactionTab, dateFilter, minAmount, maxAmount, transactions]);

  const handleTransfer = () => {
    if (!bankAccount.accountNumber || !bankAccount.ifsc) {
      setTransferStatus("Please add bank account details first");
      return;
    }

    if (transfersLeft <= 0) {
      setTransferStatus("No transfers left this week");
      return;
    }

    const amount = parseFloat(transferAmount);
    if (isNaN(amount) || amount <= 0) {
      setTransferStatus("Please enter a valid amount");
      return;
    }

    if (amount > walletBalance) {
      setTransferStatus("Amount exceeds wallet balance");
      return;
    }

    setIsProcessing(true);

    // Simulate API call
    setTimeout(() => {
      // Create new withdrawal transaction
      const newTransaction = {
        id: `w${Date.now()}`,
        type: "withdrawal",
        amount: -amount,
        date: new Date(),
        status: "pending",
        reference: `TRX-${Math.floor(100000 + Math.random() * 900000)}`
      };

      setTransactions(prev => [...prev, newTransaction]);
      setTransfersLeft(prev => prev - 1);
      setTransferStatus(`₹${amount.toFixed(2)} transfer initiated successfully!`);
      setTransferAmount("");
      setIsProcessing(false);

      // Close modal after success
      setTimeout(() => setShowTransferModal(false), 2000);
    }, 1500);
  };

  const saveBankAccount = () => {
    if (!bankAccount.holderName || !bankAccount.accountNumber || !bankAccount.ifsc) {
      setTransferStatus("Please fill all required fields");
      return;
    }

    // Simulate saving to backend
    localStorage.setItem("driverBankAccount", JSON.stringify(bankAccount));
    setTransferStatus("Bank account saved successfully!");

    // Close modal after success
    setTimeout(() => setShowAccountModal(false), 1500);
  };

  const resetFilters = () => {
    setDateFilter({ from: null, to: null });
    setMinAmount("");
    setMaxAmount("");
  };

  // Load saved bank account
  useEffect(() => {
    const savedAccount = localStorage.getItem("driverBankAccount");
    if (savedAccount) {
      setBankAccount(JSON.parse(savedAccount));
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 relative pb-20 mt-40">
      {/* Tabs */}
      <div className="w-full bg-gray-100 p-1 sticky top-0 z-10">
        <div className="grid w-full grid-cols-2 gap-1">
          <button
            onClick={() => setActiveTab("all")}
            className={`py-2 px-4 rounded-full text-sm sm:text-base ${activeTab === "all" ? "bg-[#062D51] text-white" : ""}`}
          >
            All Earnings
          </button>
          <button
            onClick={() => setActiveTab("wallet")}
            className={`py-2 px-4 rounded-full text-sm sm:text-base ${activeTab === "wallet" ? "bg-[#062D51] text-white" : ""}`}
          >
            Wallet
          </button>
        </div>
      </div>

      {/* All Earnings View */}
      {activeTab === "all" && (
        <div className="m-4">
          <Card className="p-6">
            <div className="text-center">
              <div className="text-2xl sm:text-3xl font-semibold text-green-600">
                ₹{totalEarnings.toFixed(2)}
              </div>
              <div className="text-green-600 mt-2 text-sm sm:text-base">Total Earnings</div>
            </div>
            <div className="mt-4 text-center text-xs sm:text-sm text-gray-500">
              (Net earnings after GST and platform fees)
            </div>
          </Card>
        </div>
      )}

      {/* Wallet View */}
      {activeTab === "wallet" && (
        <div className="m-4">
          <Card className="p-6">
            <div className="text-center">
              <div className="text-2xl sm:text-3xl font-semibold text-red-500">₹{walletBalance.toFixed(2)}</div>
              <div className="text-red-500 mt-2 text-sm sm:text-base">Your wallet balance</div>
            </div>

            {/* <div className="grid grid-cols-2 gap-4 mt-6 border-t pt-4">
              <div
                className="text-center cursor-pointer"
                onClick={() => setShowAccountModal(true)}
              >
                <div className="bg-gray-100 w-10 h-10 sm:w-12 sm:h-12 mx-auto rounded-lg flex items-center justify-center mb-2">
                  <img src={SVG} className="h-8 w-8 sm:h-10 sm:w-10" alt="Add Account" />
                </div>
                <div className="font-medium text-sm sm:text-base">Bank Account</div>
              </div>
              <div
                className="text-center cursor-pointer"
                onClick={() => setShowTransferModal(true)}
              >
                <div className="bg-gray-100 w-10 h-10 sm:w-12 sm:h-12 mx-auto rounded-lg flex items-center justify-center mb-2">
                  <FaMoneyBillTransfer className="h-5 w-5 sm:h-6 sm:w-6" />
                </div>
                <div className="font-medium text-sm sm:text-base">Transfer Left: {transfersLeft}</div>
              </div>
            </div> */}
          </Card>
          <div className="mx-1 mt-4 p-4 bg-white rounded-lg flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
            <div>
              <h1 className="font-semibold text-sm sm:text-base">Rules :</h1>
            </div>
            <div className="text-gray-600 text-xs sm:text-sm">
              Money transfer renews every Monday
            </div>
            <div className="text-gray-600 text-xs sm:text-sm">
              Minimum transfer: ₹100
            </div>
          </div>
        </div>
      )}

      {/* Transactions Section */}
      <div className="mt-6 p-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-4 gap-3">
          <h2 className="text-lg sm:text-xl font-semibold">Transaction History</h2>
          <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
            <div className="flex flex-row sm:flex-col items-start sm:items-center border rounded-md px-2 py-1 text-sm gap-1 sm:gap-2 w-full">
              <div className="flex items-center">
                <label className="mr-1 text-xs sm:text-sm">From:</label>
                <input
                  type="date"
                  value={dateFilter.from ? new Date(dateFilter.from).toISOString().split('T')[0] : ''}
                  onChange={(e) => setDateFilter({ ...dateFilter, from: new Date(e.target.value) })}
                  className="border rounded p-1 text-xs sm:text-sm"
                />
              </div>
              <div className="flex items-center">
                <label className="mr-1 text-xs sm:text-sm"> - To:</label>
                <input
                  type="date"
                  value={dateFilter.to ? new Date(dateFilter.to).toISOString().split('T')[0] : ''}
                  onChange={(e) => setDateFilter({ ...dateFilter, to: new Date(e.target.value) })}
                  className="border rounded p-1 text-xs sm:text-sm"
                />
              </div>
            </div>
            <div className="flex gap-1">
              <div><label className="text-xs sm:text-sm ml-2">Amount:</label></div>
              <input
                type="number"
                placeholder="Min ₹"
                value={minAmount}
                onChange={(e) => setMinAmount(e.target.value)}
                className="w-16 sm:w-20 border rounded p-1 text-xs sm:text-sm"
              /> -
              <input
                type="number"
                placeholder="Max ₹"
                value={maxAmount}
                onChange={(e) => setMaxAmount(e.target.value)}
                className="w-16 sm:w-20 border rounded p-1 text-xs sm:text-sm"
              />
            </div>
            <Button
              variant="outline"
              onClick={resetFilters}
              className="text-xs sm:text-sm"
            >
              Reset
            </Button>
          </div>
        </div>

        <div className="flex gap-6 border-b mb-6 overflow-x-auto">
          <button
            className={`pb-2 whitespace-nowrap ${transactionTab === "all" ? "border-b-2 border-black font-medium" : "text-gray-500"}`}
            onClick={() => setTransactionTab("all")}
          >
            All transactions
          </button>
          <button
            className={`pb-2 whitespace-nowrap ${transactionTab === "pending" ? "border-b-2 border-black font-medium" : "text-gray-500"}`}
            onClick={() => setTransactionTab("pending")}
          >
            Pending
          </button>
          <button
            className={`pb-2 whitespace-nowrap ${transactionTab === "completed" ? "border-b-2 border-black font-medium" : "text-gray-500"}`}
            onClick={() => setTransactionTab("completed")}
          >
            Completed
          </button>
        </div>

        {filteredTransactions.length > 0 ? (
          <div className="space-y-4">
            {filteredTransactions.map((transaction) => (
              <Card key={transaction.id} className="p-3 sm:p-4">
                <div className="flex justify-between items-start sm:items-center">
                  <div className="flex-1 min-w-0">
                    <div className="font-medium text-sm sm:text-base truncate">
                      {transaction.type === "ride"
                        ? `Ride from ${transaction.from} to ${transaction.to}`
                        : "Funds Transfer"}
                    </div>
                    <div className="text-xs sm:text-sm text-gray-500">
                      {new Date(transaction.date).toLocaleString()}
                    </div>
                    {transaction.passenger && (
                      <div className="text-xs text-gray-500">
                        Passenger: {transaction.passenger}
                      </div>
                    )}
                    {transaction.status === "pending" && (
                      <div className="text-xs text-yellow-600 mt-1">
                        Settlement in 24-48 hours
                      </div>
                    )}
                  </div>
                  <div className={`text-right ml-2 ${
                    transaction.type === "ride" 
                      ? transaction.netAmount > 0 ? 'text-green-600' : 'text-red-600'
                      : transaction.amount > 0 ? 'text-green-600' : 'text-red-600'
                  }`}>
                    <div className="font-medium text-sm sm:text-base">
                      {transaction.type === "ride" 
                        ? `₹${transaction.netAmount.toFixed(2)}`
                        : `₹${Math.abs(transaction.amount).toFixed(2)}`}
                    </div>
                    <div className={`text-xs px-2 py-1 rounded-full ${
                      transaction.status === 'completed'
                        ? 'bg-green-100 text-green-800'
                        : transaction.status === 'failed'
                          ? 'bg-red-100 text-red-800'
                          : 'bg-yellow-100 text-yellow-800'
                    }`}>
                      {transaction.status.charAt(0).toUpperCase() + transaction.status.slice(1)}
                    </div>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        ) : (
          <div className="text-center py-8">
            <div className="w-20 h-20 sm:w-24 sm:h-24 mx-auto mb-4 bg-gray-100 rounded-lg flex items-center justify-center">📝</div>
            <div className="text-gray-500 text-sm sm:text-base">No transactions found</div>
          </div>
        )}
      </div>

      {/* Transfer Modal */}
      {showTransferModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg p-4 sm:p-6 w-full max-w-md">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg sm:text-xl font-semibold">Transfer Funds</h2>
              <button
                onClick={() => {
                  setShowTransferModal(false);
                  setTransferStatus("");
                }}
                className="text-lg"
              >
                ✕
              </button>
            </div>
            <p className="text-gray-600 mb-4 text-sm sm:text-base">Transfer money to your bank account</p>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-1">
                  Amount (₹)
                </label>
                <input
                  type="number"
                  value={transferAmount}
                  onChange={(e) => setTransferAmount(e.target.value)}
                  placeholder="Enter amount"
                  className="w-full p-2 border rounded text-sm sm:text-base"
                />
                <div className="text-xs text-gray-500 mt-1">
                  Available: ₹{walletBalance.toFixed(2)}
                </div>
              </div>

              {bankAccount.accountNumber ? (
                <div className="border rounded-lg p-3">
                  <div className="font-medium text-sm sm:text-base">{bankAccount.holderName}</div>
                  <div className="text-xs sm:text-sm">
                    {bankAccount.bankName} | ●●●● {bankAccount.accountNumber.slice(-4)}
                  </div>
                </div>
              ) : (
                <div className="text-center py-4 text-sm text-gray-500">
                  No bank account added
                </div>
              )}

              {transferStatus && (
                <div className={`p-2 rounded text-center text-sm ${transferStatus.includes("success")
                  ? "bg-green-100 text-green-700"
                  : "bg-red-100 text-red-700"
                  }`}>
                  {transferStatus}
                </div>
              )}

              <div className="flex gap-2">
                <button
                  onClick={() => {
                    setShowTransferModal(false);
                    setTransferStatus("");
                  }}
                  className="flex-1 py-2 border rounded text-sm sm:text-base"
                >
                  Cancel
                </button>
                <button
                  onClick={handleTransfer}
                  disabled={isProcessing}
                  className={`flex-1 py-2 rounded text-sm sm:text-base ${isProcessing ? "bg-gray-400" : "bg-[#062D51] text-white"
                    }`}
                >
                  {isProcessing ? "Processing..." : "Transfer Now"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Bank Account Modal */}
      {showAccountModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg p-4 sm:p-6 w-full max-w-md">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg sm:text-xl font-semibold">Bank Account Details</h2>
              <button
                onClick={() => {
                  setShowAccountModal(false);
                  setTransferStatus("");
                }}
                className="text-lg"
              >
                ✕
              </button>
            </div>
            <p className="text-gray-600 mb-4 text-sm sm:text-base">Add your bank account for transfers</p>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-1">
                  Account Holder Name
                </label>
                <input
                  value={bankAccount.holderName}
                  onChange={(e) => setBankAccount({ ...bankAccount, holderName: e.target.value })}
                  placeholder="Enter full name"
                  className="w-full p-2 border rounded text-sm sm:text-base"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Account Number
                </label>
                <input
                  value={bankAccount.accountNumber}
                  onChange={(e) => setBankAccount({ ...bankAccount, accountNumber: e.target.value })}
                  placeholder="Enter account number"
                  className="w-full p-2 border rounded text-sm sm:text-base"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  IFSC Code
                </label>
                <input
                  value={bankAccount.ifsc}
                  onChange={(e) => setBankAccount({ ...bankAccount, ifsc: e.target.value })}
                  placeholder="Enter IFSC code"
                  className="w-full p-2 border rounded text-sm sm:text-base"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Bank Name
                </label>
                <input
                  value={bankAccount.bankName}
                  onChange={(e) => setBankAccount({ ...bankAccount, bankName: e.target.value })}
                  placeholder="Enter bank name"
                  className="w-full p-2 border rounded text-sm sm:text-base"
                />
              </div>

              {transferStatus && (
                <div className={`p-2 rounded text-center text-sm ${transferStatus.includes("success")
                  ? "bg-green-100 text-green-700"
                  : "bg-red-100 text-red-700"
                  }`}>
                  {transferStatus}
                </div>
              )}

              <button
                onClick={saveBankAccount}
                className="w-full py-2 bg-[#062D51] text-white rounded text-sm sm:text-base"
              >
                Save Account Details
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default EarningsPage;